import React from 'react'
import UAParser from 'ua-parser-js'

import ScrollAnimation from 'react-animate-on-scroll'
import style from './footer.module.scss'

export const isMobile = () =>
  new UAParser().getResult().device.type === 'mobile'
export const isTablet = () =>
  new UAParser().getResult().device.type === 'tablet'

class Footer extends React.Component {
  jobSeekerHelpClick() {
    window.open(
      this.href,
      'pop',
      'toolbar=no,directories=no,location=no,status=yes,menubar=no,resizable=yes,scrollbars=yes,width=998,height=800'
    )
  }

  employerHelpClick() {
    window.open(
      this.href,
      'pop',
      'toolbar=no,directories=no,location=no,status=yes,menubar=no,resizable=yes,scrollbars=yes,width=681,height=800'
    )
  }

  contactClick() {
    window.open(
      this.href,
      'pop',
      'toolbar=no,directories=no,location=no,status=yes,menubar=no,resizable=yes,scrollbars=yes,width=681,height=1053'
    )
  }

  contactPopupClick() {
    window.open(
      this.href,
      'pop',
      'toolbar=no,directories=no,location=no,status=yes,menubar=no,resizable=yes,scrollbars=yes,width=681,height=1053'
    )
  }

  render() {
    return (
      <footer role="contentinfo" className={style.footer}>
        <div className={style.col20}>
          <ScrollAnimation
            animateIn="monsterSlideIn"
            duration={0.7}
            offset={120}
          >
            <a
              title="Go to Monster home"
              href="https://www.monster.com"
              className={style.mLogo}
            >
              <img
                src={require('../images/icon.svg')}
                height="68"
                alt="Monster icon"
              />
            </a>
          </ScrollAnimation>
        </div>
        {!isMobile() && !isTablet() ? (
          <>
            <div className={style.col20}>
              <ul>
                <li>
                  <h3>
                    <strong>For Job Seekers</strong>
                  </h3>
                </li>
                <li>
                  <a href="https://www.monster.com/jobs/">Find Jobs</a>
                </li>
                <li>
                  <a href="https://www.monster.com/resumes/post-resume2">
                    Upload Resume
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <h3>
                    <strong>For Employers</strong>
                  </h3>
                </li>
                <li>
                  <a href="https://hiring.monster.com/">Post Jobs</a> /{' '}
                  <a href="https://hiring.monster.com/recruitment/Resume-Search-Database.aspx">
                    Search Resumes
                  </a>
                </li>
                <li>
                  <a href="#">Employer Branding</a>
                </li>
                <li>
                  <a href="#">Full Service Sourcing</a>
                </li>
                <li>
                  <a href="#">Custom HR Software</a>
                </li>
                <li>
                  <a href="#">For Staffing Agencies</a>
                </li>
                <li>
                  <a href="https://www.monster.com/sitemap">Site Map</a>
                </li>
              </ul>
              <ul>
                <li>
                  <h3>
                    <strong>About Us</strong>
                  </h3>
                </li>
                <li>
                  <a href="https://www.monster.com/about">About Monster</a>
                </li>
                <li>
                  <a href="https://careers.monster.com/">Work for Monster</a>
                </li>
                <li>
                  <a href="http://partner.monster.com/">Partner with Us</a>
                </li>
                <li>
                  <a href="https://www.monster.com/geo/siteselection">
                    Monster International
                  </a>
                </li>
              </ul>
            </div>
            <div className={style.col20}>
              <ul>
                <li>
                  <h3>
                    <strong>Employer Resources</strong>
                  </h3>
                </li>
                <li>
                  <a href="#">Resource Center</a>
                </li>
                <li>
                  <a href="#">Job Description Templates</a>
                </li>
                <li>
                  <a href="#">Recruiting Strategies</a>
                </li>
                <li>
                  <a href="#">Workforce Management</a>
                </li>
                <li>
                  <a href="#">Monster Training</a>
                </li>
                <li>
                  <a href="#">Small Business Hiring</a>
                </li>
                <li>
                  <a href="#">Blog</a>
                </li>
              </ul>
              <ul>
                <li>
                  <h3>
                    <strong>Support</strong>
                  </h3>
                </li>
                <li>
                  <a href="https://monster.secure.force.com/ekb/EKBContactUs?brand=seeker">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#">Using Monster Training</a>
                </li>
                <li>
                  <a href="https://monster.secure.force.com/ekb/EKBHome?brand=seeker">
                    Help
                  </a>
                </li>
                <li>
                  <a href="http://inside.monster.com/terms-of-use">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="http://inside.monster.com/privacy/home.aspx">
                    Privacy Center
                  </a>
                </li>
                <li>
                  <a href="http://inside.monster.com/security-center/home.aspx">
                    Security Center
                  </a>
                </li>
                <li>
                  <a href="#">OFCCP Information</a>
                </li>
              </ul>
            </div>
          </>
        ) : (
          <ul>
            <li>
              <h3>
                <a href="https://hiring.monster.com/">Post a Job</a> /{' '}
                <a href="https://hiring.monster.com/recruitment/Resume-Search-Database.aspx">
                  Search Resumes
                </a>
              </h3>
            </li>
            <li>
              <h3>
                <a href="https://www.monster.com/pricing">Pricing</a>
              </h3>
            </li>
            <li>
              <h3>
                <a href="https://www.monster.com/about">About Monster</a>
              </h3>
            </li>
            <li>
              <h3>
                <a href="https://monster.secure.force.com/ekb/EKBContactUs?brand=seeker">
                  Contact Us
                </a>
              </h3>
            </li>
            <li>
              <h3>
                <a href="http://inside.monster.com/terms-of-use">
                  Terms of Use
                </a>
              </h3>
            </li>
            <li>
              <h3>
                <a href="http://inside.monster.com/privacy/home.aspx">
                  Privacy Center
                </a>
              </h3>
            </li>
            <li>
              <h3>
                <a href="http://inside.monster.com/security-center/home.aspx">
                  Security Center
                </a>
              </h3>
            </li>
          </ul>
        )}
        <div className={style.col40}>
          <div>
            <ul className={style.flex}>
              <li>
                <a href="https://www.facebook.com/monster" target="_blank">
                  <img
                    className={style.footerSocialIcons}
                    src={require('../images/004-facebook-logo.svg')}
                    alt="Facebook"
                  />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/Monster" target="_blank">
                  <img
                    className={style.footerSocialIcons}
                    src={require('../images/003-twitter-social-logotype.svg')}
                    alt="Twitter"
                  />
                </a>
              </li>
              <li>
                <a href="https://instagram.com/monster" target="_blank">
                  <img
                    className={style.footerSocialIcons}
                    src={require('../images/005-instagram.svg')}
                    alt="Instagram"
                  />
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/monster" target="_blank">
                  <img
                    className={style.footerSocialIcons}
                    src={require('../images/002-youtube-symbol.svg')}
                    alt="Youtube"
                  />
                </a>
              </li>
              <li>
              	<a href="https://www.pinterest.com/monsterdotcom/" target="_blank">
	                <img
	                  className={style.footerSocialIcons}
	                  src={require('../images/001-pinterest-social-logo.svg')}
	                  alt="Pinterest"
	                />
	              </a>
              </li>
            </ul>
          </div>
          <div className={style.copyright}>
            <p>Copyright © 2019 - Monster Worldwide</p>
            <p>U.S. Patents No. 7,599,930 B1; 7,827,125 and 7,836,060</p>
            <img
              className={style.seal}
              src={require('../images/seal.png')}
              alt="eTrust Seal"
            />
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
